/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/15/19
 * Copyright All Rights Reserved
 */

// @flow
import React, { useEffect } from 'react';
import { values, pick } from 'lodash/fp';
import { Row } from 'reactstrap';
import Header from 'components/support/layout/Header';
import Main from 'components/support/layout/MainContainer';
import Page from 'components/support/layout/Page';
import { Sidebar, SidebarComplement } from 'components/support/layout/Sidebar';
import InventoryPageControlForm from './InventoryPageControlForm';
import InventoryMap from './InventoryMap';
import PortfolioResultSummary from './InventoryResultSummary';
import getInitialValues from 'support/inventoryPageControlForm/getInitialValues';
import paramsAreSet from 'support/paramsAreSet';
import { allSearchParams } from 'constants/searchParams';
import type { AllSearchParams } from 'constants/searchParams';

type Props = {
  analysisType: string,
  inventoryId: string,
  fetchCurrentInventoryDetails: Function,
  fetchInventories: Function,
  ...AllSearchParams,
};

const InventoryPage = (props: Props) => {
  const {
    inventoryId,
    analysisType,
    fetchCurrentInventoryDetails,
    fetchInventories,
  } = props;
  useEffect(() => {
    fetchInventories();
  }, []);

  useEffect(() => {
    if (inventoryId && analysisType && paramsAreSet(analysisType, props)) {
      fetchCurrentInventoryDetails();
    }
  }, [inventoryId, analysisType, ...values(pick(allSearchParams, props))]);

  const initialValues = getInitialValues({
    inventoryId, analysisType, ...pick(allSearchParams, props),
  });

  return (
    <Page className="inventory-page">
      <Header />
      <Main>
        <Row>
          <Sidebar>
            <InventoryPageControlForm
              inventoryId={inventoryId}
              analysisType={analysisType}
              initialValues={initialValues}
            />
            <PortfolioResultSummary {...initialValues} />
          </Sidebar>
          <SidebarComplement>
            <InventoryMap {...initialValues} />
          </SidebarComplement>
        </Row>
      </Main>
    </Page>
  );
};

export default InventoryPage;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPage.jsx